import(/* webpackMode: "eager" */ "/app/app/comunidade/page.tsx");
